<template>
  <div class="col-md-4" id="bab-content">
      <div class="panel panel-inverse">
            <div class="panel-heading">
              <div class="btn-group pull-right">
                <button type="button" class="btn btn-danger btn-xs" @click="deleteBab(datalist.id)">
                  <i class="fa fa-close"></i>
                </button>
              </div>
              
              <h4 class="panel-title">{{datalist.bab_name}} 
                <span v-if="datalist.name !== ''"> - {{ datalist.name }}</span>
              </h4>
              
            </div>
            <div class="button-group">
                <div class="row" style="width:100%;padding:10px;">
                    <div class="col-sm-4" >
                        <button class="btn btn-info btn-xs"  data-toggle="modal" data-target="#addBabModal" @click="$emit('editBab', datalist)">
                          <i class="fa fa-edit"></i>
                          Edit Bab
                        </button>
                    </div>
                    <div class="col-sm-5">
                        <button class="btn btn-primary btn-xs" @click="addContentButton(datalist.id)">
                          <i class="fa fa-plus"></i>
                          Tambah Konten
                        </button>
                    </div>
                    <div class="col-sm-3">
                        <button :class="updateState === 1 ? 'btn btn-warning btn-xs' : 'btn btn-light btn-xs'" :disabled="updateState === 1 ? false : true" @click="updateKontenOrder(datalist.id)">
                          <i class="fa fa-refresh"></i>
                          Update
                        </button>
                    </div>
                </div>
            </div>
            <div class="drag-content">
                <div v-if="list.length === 0" style="padding:20px; text-align:center;">
                  Belum Ada Konten
                </div>
                <draggable class="list-group" tag="ul" v-model="list" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
                    <transition-group type="transition" :name="'flip-list'">
                      
                    <li class="list-group-item" v-for="element in list" :key="element.id">
                      <div class="row">
                        <div class="col-md-3">
                          <img :src="element.type.picture" width="50"/>
                        </div>
                        <div class="col-md-6">
                          <h6><b>{{element.type.type}} - {{element.title}}</b></h6>
                        </div>
                        <div class="col-md-3">
                          <button class="btn btn-danger btn-xs" @click="deleteContent(element.id)">
                            <i class="fa fa-close"></i>
                          </button>
                          <button class="btn btn-info btn-xs" @click="editContent(element)" >
                            <i class="fa fa-pencil"></i>
                          </button>
                        </div>
                      </div>
                    </li>
                    </transition-group>
                </draggable>
            </div>
      </div>
    
    
    <app-modal v-if="showModal" :withCancel="true" v-on:ok="removeDependency()" v-on:cancel="showModal = false">
      <h4 slot="header">Hapus Pra-Syarat</h4>
      <div slot="body">Apakah anda yakin akan menghapus pra-syarat <strong style="color: red">{{dependencyName}}</strong> ?</div>
    </app-modal>
  </div>
</template>

<style scoped>
    .panel-body{
        padding-bottom: 5px;
    }
    .button-group {
        width:100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px;
    }
    .drag-content{
        background-color:#E9ECEF;
        max-height: 300px;
        min-height: 300px;
        overflow-x: auto;
    }
    .list-group-item{
      border-radius: 12px;
      margin:3px;
    }

    .nav.nav-tabs{
      padding-top:5px;
      padding-bottom: 5px;
      padding-left: 10px;
    }
    .modal-body {
      /* overflow: hidden; */
      margin: 0px;
    }
</style>
<script>
import draggable from 'vuedraggable'
import BabBimbelService from '@/services/bimbel_bab.js'
import MateriBimbelService from '@/services/bimbel_materi.js'
import TryoutGroupChooser from '@/components/tryout_group/TryoutGroupChooser'
import Modal from '@/components/plugins/Modal'
import Autocomplete from '@/components/plugins/Autocomplete'

export default {
  name: 'bab-components',
  components: {
      draggable,
      'app-tryoutgroupchooser': TryoutGroupChooser,
      'app-modal': Modal,
      'app-autocomplete': Autocomplete,
  },
  props: {
    datalist: { type: Object, default: [''] },
    mapelid: { type: Object, default: null },
    indexProp: { type: Number, default: null }, 
  },
  data() {
    return {
      errorVideo: [],
      errorMateri: [],
      errorSoal: [],
      errorTryout: [],
      errorTerjadwal: [],
      list:[],
      list2: [],
      editable: true,
      isDragging: false,
      delayedDragging: false,
      jenjangList: ['SD', 'SMP', 'SMA'],
      gradeList: [1,2,3,4,5,6,7,8,9,10,11,12],
      mapelList: JSON.parse(localStorage.getItem('mapels')),
      babList: [],
      subBabList: [],
      jenjang: this.mapelid.jenjang,
      kelas: this.mapelid.grade,
      listVideo: [],
      updateState: 0,
      video_judul: '',
      video_judul_alt: '',
      materi_judul: '',
      type_id: 1,
      file: '',
      file_url: '',
      validFile: 0,
      babSelected: '',
      subBabSelected: '',
      typeTO: 'SBMPTN',
      variant: 'SCHEDULED',
      showModal: false,
      TOSelected: [],
      dependencyName: '',
      idContent: null,
      updateSwitch: null,
      autoValueSubBab: '',
      autoValueBab: '',
      TOFromEdit: ''
    };
  },
  methods: {
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    addContentButton(sectionid) {
      this.$router.push('?section='+ sectionid)
      this.$emit('addingcontent', '')
    },
    deleteContent: function (id) {
			var context = this
      var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?")
      if (confirmed) {
        this.isLoading = true
        MateriBimbelService.deleteContent(id, (result) => {
          if (result.success) {
            context.isLoading = false
            context.$emit('reload', '')
            setTimeout(function() {
              alert('Data Terhapus')
            }, 1200)
          }
        })
      }
    },
    editContent: function (item) {
      this.$router.push('?section=' + this.datalist.id)
      this.$emit('throwEdit', item)
    },
    deleteBab: function (id) {
      var context = this
      // this.isLoading = true
      var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?")
      if (confirmed) {
        // context.isLoading = false
        BabBimbelService.deleteBab(id, (result) => {
          if (result.success) {
            alert('Data Terhapus')
            context.$emit('reload', '')
          }
        })
      }
    },
    updateKontenOrder: function (id) {
      var reorder = []
      for(var i = 0; i < this.list.length; i++) {
        reorder.push({
          id: this.list[i].id,
          sequence: i + 1
        })
      }
      var context = this
      var confirmed = window.confirm("Apakah anda yakin akan mengubah susunan konten bab ini?")
      if (confirmed) {
        // this.isLoading = true
        BabBimbelService.reOrderKonten([reorder, id], (result) => {
          if (result.success) {
            // context.isLoading = false
            alert('Data telah disusun ulang')
            context.updateState = 0
            context.$emit('reload', '')
          }
        })
      }
    },    
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      }
    },
  },
  created(){
    this.list = this.datalist.details
    console.log(this.datalist)
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        this.updateState = 1
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// Bab.vue?5ac60e58